<template>
	<div @blur="open = false" class="position-relative" @focus="handleFocus" @focusout="handleFocusOut" tabindex="0">
		<div :class="{ open: open }" @click="open = !open" class="form-select _custom-select" role="button" v-html="modelName"></div>

		<ul :class="{ 'd-none': !open }" class="position-absolute list-group mt-1" style="z-index: 1070">
			<li v-for="(option, i) of options" :key="i" @click="update(option.value)" class="list-group-item" role="button" v-html="option.name"></li>
		</ul>
	</div>
</template>

<script>
export default {
	emits: ["update:modelValue"],
	props: {
		modelValue: String,
		options: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			open: false,
		};
	},
	computed: {
		modelName: function () {
			if (this.options) {
				return this.options.find((o) => o.value === this.modelValue).name;
			}
		},
	},
	methods: {
		update(option) {
			this.open = false;
			this.$emit("update:modelValue", option);
		},
		handleFocusOut() {
			this.open = false;
		},
	},
};
</script>
